import React from "react";
import './ToggleSwitch.css'

const ToggleSwitch = ({ row, checked, disabled, handleToggle, idSuffix = "toggle" }) => {
    const inputId = `${idSuffix}-${row.id}`;
    return (
        <div>
            <input
                className="toggle-switch"
                type="checkbox"
                name="checkbox"
                id={inputId}
                disabled={disabled}
                checked={checked}
                onChange={(e) => handleToggle(e, row)}
            />
            <label htmlFor={inputId} className="switch"></label>
        </div>
    )
}

export default ToggleSwitch